module.exports = __webpack_public_path__ + "img/img011.b64c49af.png";